
import "./style.scss";
import gsap from "gsap";

export default class Player {
    constructor(videoLink) {

        const that = this;
        this.videoLink = videoLink;

        this.hasControls = true;
    }

    create = async () => {
        this.player = document.createElement('div');
        this.player.className = 'player__overlay';
        document.querySelector('body').append(this.player);
    
        this.video = document.createElement('video');
        this.video.src = this.videoLink.href;
        this.player.append(this.video);

        this.buttonClose = document.createElement('a');
        this.buttonClose.className = 'player__close';
        this.player.append(this.buttonClose);

        this.cursor = document.createElement('div');
        this.cursor.className = 'player__cursor';
        this.player.append(this.cursor);

        gsap.to('.player__close', {
            x: window.innerWidth/2,
            y: window.innerHeight/2,
            scale:1,
            opacity:1,
            duration:0.5
        });
        function moveButtonClose(e) {
            gsap.to('.player__close', {
                x: e.clientX,
                y: e.clientY,
                duration:0.3
            });
            gsap.to('.player__cursor', {
                x: e.clientX,
                y: e.clientY,
                duration:0.3
            });
        }

        this.player.addEventListener('mousemove', moveButtonClose);

        if ( this.hasControls ) this.addControls();
    }

    open () {
        this.create();

        const that = this;
        gsap.to('.player__overlay',{opacity:1});
        this.video.play();
        this.video.addEventListener("ended", (event) => {
            if (window.innerWidth<992) {
                if (video.exitFullscreen) 
                video.exitFullscreen();
                else if (video.webkitExitFullscreen) 
                video.webkitExitFullscreen();
                else if (video.msRequestExitFullscreen) 
                video.msRequestExitFullscreen();
            }
            that.close();
        });
        if (window.innerWidth<992) {
            if (this.video.requestFullscreen) 
            this.video.requestFullscreen();
            else if (this.video.webkitRequestFullscreen) 
            this.video.webkitRequestFullscreen();
            else if (this.video.msRequestFullScreen) 
            this.video.msRequestFullScreen();
        }
    
        this.video.addEventListener("click", (event) => {
            that.close();
        });
    
    }

    close() {
        gsap.to('.player__overlay',{opacity:0, onComplete:()=> { this.destroy() }});
    }

    destroy() {
        this.player.remove();
    }

    addControls() {
        const that = this;

        this.playerControls = document.createElement('div');
        this.playerControls.className = 'player__controls';
        this.player.append(this.playerControls);
        this.playerControls.addEventListener('mouseenter', function(){
            gsap.to(that.buttonClose, { scale:0 })
            gsap.to(that.cursor, { scale:1 })
        })
        this.playerControls.addEventListener('mouseleave', function(){
            gsap.to(that.buttonClose, { scale:1 })
            gsap.to(that.cursor, { scale:0 })
        })

        // play button
        this.playButton = document.createElement('div');
        this.playButton.className = 'player__controls__play';
        this.playButton.innerHTML = '❚❚';
        this.playerControls.append(this.playButton);
        this.playButton.addEventListener('click', function(){
            if ( !that.video.paused ) that.video.pause();
            else that.video.play();
            that.togglePlayButton();
        });
        
        // progress
        this.progress = document.createElement('div');
        this.progress.className = 'player__controls__progress';
        this.progressBar = document.createElement('span');
        this.progress.append(this.progressBar);
        this.playerControls.append(this.progress);
        this.video.addEventListener('timeupdate', function(){
            that.handleProgress();
        });
        
        // mute button
        this.muteButton = document.createElement('div');
        this.muteButton.className = 'player__controls__mute';
        this.muteButton.innerHTML = 'mute';
        this.playerControls.append(this.muteButton);
        this.muteButton.addEventListener('click', function(){
            if ( !that.video.muted ) that.video.muted = true;
            else that.video.muted = false;
            that.toggleMuteButton();
        });


    }

    handleProgress() {
        gsap.to(this.progressBar, { width: (this.video.currentTime / this.video.duration) * 100 +'%'});
    }

    togglePlayButton() {
        this.playButton.innerHTML = this.video.paused ? "►" : "❚❚";
    }

    toggleMuteButton() {
        this.muteButton.innerHTML = this.video.muted ? "Unmute" : "Mute";
    }
}

const videoLinks = document.querySelectorAll('.player-link');
videoLinks.forEach(function(videoLink){
    const player = new Player(videoLink);
    videoLink.addEventListener('click',function(e){
        e.preventDefault();
        player.open();
    })
})



